import classNames from 'classnames';

import { WinnerConveyor } from './components/WinnerConveyor/WinnerConveyor';
import { useConveyorCapacity } from './hooks/useConveyorCapacity';
import { useTileGeometry } from './hooks/useTileGeometry';
import { useWinners } from './hooks/useWinners';
import styles from './WinnersBanner.module.scss';

type WinnersBannerProps = {
  fullWidth?: boolean;
};

export function WinnersBanner({ fullWidth = false }: WinnersBannerProps) {
  const { tiles, loading } = useWinners();
  const geometry = useTileGeometry();
  const { viewportRef, containerWidth, minSlots } = useConveyorCapacity(geometry.stride);

  const show = !loading && tiles.length >= minSlots;

  return (
    <div
      ref={viewportRef}
      className={classNames(styles.banner, {
        [styles.fullWidth]: fullWidth,
        [styles.collapsed]: !show,
      })}
      data-testid="winners-banner"
    >
      {show && (
        <WinnerConveyor containerWidth={containerWidth} geometry={geometry} tiles={tiles} viewportRef={viewportRef} />
      )}
    </div>
  );
}
